import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Map } from "immutable";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import * as actions from "MODULES/PurchaseOrders/actions";
import Form from "./Form";

function EditDiscrepancy({ open, close, receivingRecord, discrepancy }) {
  const initialValues = {
    read_only_part_number: receivingRecord.getIn(["part", "part_number"]),
    read_only_serial_number: receivingRecord.get("serial_number"),
    id: discrepancy && discrepancy.id,
    reason: discrepancy && discrepancy.reason,
    discrepancy_type: discrepancy && discrepancy.discrepancy_type,
    reason_for_resolution: discrepancy && discrepancy.reason_for_resolution,
    escalate_discrepancy: discrepancy && discrepancy.escalate_discrepancy
  };

  return (
    <Modal open={open} close={close} dialogClass="modal-md">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit a Discrepancy</h4>
      </Header>
      <Form
        close={close}
        discrepancy={discrepancy}
        initialValues={initialValues}
        resolved={discrepancy && discrepancy.resolved}
        receivingRecordType={receivingRecord.getIn(["reference_record_type"])}
      />
    </Modal>
  );
}

export default connect(
  state => ({
    receivingRecord: state.receivingRecordDetail.get("receivingRecord")
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(actions.updateLineItem(ownProps.selectedLineItem.id, data))
  })
)(EditDiscrepancy);

EditDiscrepancy.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  discrepancy: PropTypes.shape({}),
  receivingRecord: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/Edit/EditDiscrepancy.jsx